import React from 'react';
import ReactDOM from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const apiKey = process.env.REACT_APP_API_KEY;
if (typeof window !== "undefined" && apiKey) {
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const request = input instanceof Request ? input : new Request(input, init);
    const url = new URL(request.url, window.location.origin);
    if (!url.pathname.startsWith("/api/")) {
      return originalFetch(input, init);
    }
    const headers = new Headers(request.headers);
    headers.set("x-api-key", apiKey);
    return originalFetch(new Request(request, { headers }));
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
